const loginConstants = {
  STATE_WHITELIST: [
    'main.search.quick.query',
    'main.search.advancedsearch',
    'main.results.context',
    'main.results.heatmap',
    'main.profile',
    'main.structure',
    'main.register',
    'main.search.quick.results',
    'main.search.synthesisplanner',
    'main.history.recent',
    'main.history.saved',
    'main.alerts',
    'main.alerts.old',
    'main.alerts.new',
    'main.hopinto',
    'main.rs',
  ],
  REGISTRATION_ONLY: 'REGISTRATION_PAGE_ONLY',
  RX2_APPLICATION: 'RX2_APPLICATION',
};

export default loginConstants;
